import PublicLayout from '../components/layouts/PublicLayout';
import { Container } from 'reactstrap';
import Image from 'next/image';
import Link from 'next/link';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react';

import TopCompanies from '../public/public/awards/Top-100-Companies.png';
import AppCompanies from '../public/public/awards/Top-App-Developers.png';
import B2BCompanies from '../public/public/awards/Top-B2B--Companies.png';
import CreativeCompanies from '../public/public/awards/Top-Creative-Design.png';
import TopDevelopers from '../public/public/awards/Top-Developers.png';
import DigitalMarketing from '../public/public/awards/Top-Digital-Marketing-Agencies.png';
import TopITServices from '../public/public/awards/Top-IT-Services-Firms.png';

function Awards({meta}) {
	const router = useRouter();
	const [loading, setLoading] = useState(false);

	return (
		<>
		 <Head>
            <meta name="keywords" content={meta ? meta.keywords : ''} />
            <title>{meta ? meta.title : ''}</title>
            <meta name="description" content={meta ? meta.description : ''} />
            <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
        </Head>
		<div className="awards-page">
			<div className="banner_breadcrumb_section" >
				<Container fluid="xl">
					<h1 className="main-heading-lg">Awards</h1>
				</Container>
			</div>
			<Container fluid="xl">
				<div className="about_sec1-intro awards-section  top-spacing" >
					<p className="description-text">Awards motivate us to do even better! We&#39;re a top talent marketplace connecting vendors and businesses with their ideal match.</p>
					<h2 className="main-heading">Here are some of our accolades</h2>
					<div className="awards-flex reset_img">
						<div className="awards-top">
							<Image src={TopCompanies} layout='fill' alt="Top-100-Companies" />
						</div>
						<div className="awards-top">
							<Image src={AppCompanies} layout='fill' alt="Top-App-Developers" />
						</div>
						<div className="awards-top">
							<Image src={B2BCompanies} layout='fill' alt="Top-B2B--Companies" />
						</div>
						<div className="awards-top">
							<Image src={CreativeCompanies} layout='fill' alt="Top-Creative-Design" />
						</div>
						<div className="awards-top">
							<Image src={TopDevelopers} layout='fill' alt="Top-Developers" />
						</div>
						<div className="awards-top">
							<Image src={DigitalMarketing} layout='fill' alt="Top-Digital-Marketing-Agencies" />
						</div>
						<div className="awards-top">
							<Image src={TopITServices} layout='fill' alt="Top-IT-Services-Firms" />
						</div>
					</div>
					<div className="awards-toprow">
						<p className="description-text">Still looking for the ideal platform for your next big project or client? You know where to look. Toprow will create a phenomenal change in the way you get things done.</p>
						<div className="award-btn-flex">
							<Link href="/agency/signup"><a className="primary-btn"><span>Learn More</span></a></Link>
						</div>
					</div>
				</div>
			</Container>
		</div>
		</>
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/awards', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}

Awards.Layout = PublicLayout;

export default Awards
